export const SIGNUP_REQUEST="singup/request";
export const SIGNUP_SUSSESS="singup/success";
export const SIGNUP_ERROR="singup/error";